<div ngbDropdown placement="bottom" id="settings" class="d-inline-block btn-group">
  <button type="button" ngbDropdownToggle class="btn btn-default dropdown-toggle" id="dropdown-settings"
    data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false">
    <span class="fa fa-align-justify"></span>
  </button>

  <div ngbDropdownMenu>
    @if ('analysis'|HasPerm) {
      <a uiSref="analysis.fetch.overview" [uiParams]="{start: year, end: year}">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-line-chart"></i>
          </div>
          <div class="icon-label">
            Auswertungen
          </div>
        </button>
      </a>
    }

    @if ('analysis.executive'|HasPerm) {
      <a uiSref="analysis.executive.liquidity">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-line-chart green"></i>
          </div>
          <div class="icon-label">
            GF Auswertungen
          </div>
        </button>
      </a>
    }

    @if ('business_order.analysis'|HasPerm) {
      <a uiSref="analysis_business_order.step" [uiParams]="{start: year, end: year}"
        >
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-line-chart"></i>
          </div>
          <div class="icon-label">
            BA Auswertungen
          </div>
        </button>
      </a>
    }

    @if ('material.analysis'|HasPerm) {
      <a uiSref="analysis_material.inventory">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-line-chart"></i>
          </div>
          <div class="icon-label">
            Material Auswertungen
          </div>
        </button>
      </a>
    }

    @if ('workload.timetable'|HasPerm) {
      <a uiSref="a.workload.timetable">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-line-chart"></i>
          </div>
          <div class="icon-label">
            Auslastungskalender
          </div>
        </button>
      </a>
    }

    @if ('invoice.automation'|HasPerm) {
      <a uiSref="a.workflow.i.invoice">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-eur" aria-hidden="true"></i>
          </div>
          <div class="icon-label">
            Rechnungslauf
          </div>
        </button>
      </a>
    }

    @if ('dunning'|HasPerm) {
      <a uiSref="a.dunning.automation">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <div class="icon-label">
            Mahnungslauf
          </div>
        </button>
      </a>
    }

    @if (('settings.calculation'|HasPerm) || ('settings.price.gold'|HasPerm)) {
      <a [uiSref]="('settings.calculation'|HasPerm) ? 'a.calculation.list' : 'a.calculation.gold'">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-table"></i>
          </div>
          <div class="icon-label">
            Kalkulationstabellen
          </div>
        </button>
      </a>
    }

    <article-config-redirect type="dropdown"></article-config-redirect>

    @if ('production.machines'|HasPerm) {
      <a uiSref="a.production.machines.list">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-gavel"></i>
          </div>
          <div class="icon-label">
            Produktions Einstellungen
          </div>
        </button>
      </a>
    }

    @if ('article.extra'|HasPerm) {
      <a uiSref="a.holiday.manage">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-calendar"></i>
          </div>
          <div class="icon-label">
            Feiertage
          </div>
        </button>
      </a>
    }

    @if ('material.settings'|HasPerm) {
      <a uiSref="a.material.article.list">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-inbox"></i>
          </div>
          <div class="icon-label">
            Materialverwaltung
          </div>
        </button>
      </a>
    }

    @if ('user.change'|HasPerm) {
      <a uiSref="a.user.list">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-user"></i>
          </div>
          <div class="icon-label">
            Benutzerverwaltung
          </div>
        </button>
      </a>
    }

    @if ('label.settings'|HasPerm) {
      <a uiSref="a.label.settings">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-print"></i>
          </div>
          <div class="icon-label">
            Etiketteneinstellungen
          </div>
        </button>
      </a>
    }


    @if ('settings.settings'|HasPerm) {
      <a uiSref="a.config.main">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <span class="fa fa-stack subscript right">
              <i class="fa fa-cog fa-stack-1x dimgray"></i>
              <i class="fa fa-cog fa-stack-2x"></i>
            </span>
          </div>
          <div class="icon-label">
            System Einstellungen
          </div>
        </button>
      </a>
    }

    @if ('settings.settings'|HasPerm) {
      <a uiSref="a.config.price_increase_flex">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <span class="fa fa-stack subscript right">
              <i class="fa fa-cog fa-stack-1x dimgray"></i>
              <i class="fa fa-euro fa-stack-2x"></i>
            </span>
          </div>
          <div class="icon-label">
            Kosten Einstellungen
          </div>
        </button>
      </a>
    }

    @if ((
      ('field_service.config'|HasPerm) ||
      ('settings.customer.industrial_sectors'|HasPerm) ||
      ('settings.customer.departments'|HasPerm) ||
      ('task.offer.rejection.reason.change'|HasPerm) ||
      ('price.increase.global'|HasPerm))) {
      <a uiSref="a.config.customer">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <span class="fa fa-stack subscript right">
              <i class="fa fa-cog fa-stack-1x dimgray"></i>
              <i class="fa fa-user fa-stack-2x"></i>
            </span>
          </div>
          <div class="icon-label">
            Kunden Einstellungen
          </div>
        </button>
      </a>
    }

    @if ('settings.settings'|HasPerm) {
      <a uiSref="a.config.pdf_text">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <span class="fa fa-stack subscript right">
              <i class="fa fa-file-o fa-stack-1x dimgray"></i>
              <i class="fa fa-user fa-stack-2x"></i>
            </span>
          </div>
          <div class="icon-label">
            Kunden Dokumente
          </div>
        </button>
      </a>
    }

    @if ('ba.list'|HasPerm) {
      <a uiSref="a.dashboard.main" [uiParams]="{dashboard: true}">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-tasks"></i>
          </div>
          <div class="icon-label">
            Dashboard
          </div>
        </button>
      </a>
    }

    @if (('plotting.list'|HasPerm)) {
      <a [href]="'/dashboard/plotting' | appHref">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <span class="fa fa-stack subscript right">
              <i class="fa fa-file-picture-o fa-stack-1x dimgray"></i>
              <i class="fa fa-tasks fa-stack-2x"></i>
            </span>
          </div>
          <div class="icon-label">
            Plotting Dashboard
          </div>
        </button>
      </a>
    }

    @if ('embp_dashboard'|HasPerm) {
      <a uiSref="a.dashboard.empb">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <span class="fa fa-stack subscript right">
              <i class="fa fa-file-text-o fa-stack-1x dimgray"></i>
              <i class="fa fa-tasks fa-stack-2x"></i>
            </span>
          </div>
          <div class="icon-label">
            EMPB Dashboard
          </div>
        </button>
      </a>
    }

    @if ((('export.customer.contact'|HasPerm) || ('business_order.analysis'|HasPerm))) {
      <a uiSref="a.export">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-download"></i>
          </div>
          <div class="icon-label">
            Export
          </div>
        </button>
      </a>
    }

    @if ('cluster.administration.info'|HasPerm) {
      <a uiSref="a.cluster.info">
        <button type="button" class="dropdown-item">
          <div class="icon">
            <i class="fa fa-server"></i>
          </div>
          <div class="icon-label">
            Cluster Informationen
          </div>
        </button>
      </a>
    }

  </div>

  <a (click)="logout()" title="Abmelden" class="btn btn-default">
    <span class="fa fa-sign-out"></span>
  </a>
</div>
